import { UStack, UText } from '@src/components'

import { PageHeaderProps } from '../type'

/**
 * Use PageContainer to ensure margin-bottom.
 */
export const PageHeader = ({ description, title }: PageHeaderProps) => {
  return (
    <UStack spacing={3} direction="column">
      <UText variant="title1">{title}</UText>
      {description && <UText>{description}</UText>}
    </UStack>
  )
}
